// scroll-effect in-view.js
(function () {
  var $elm = document.getElementsByClassName('js-scroll');
  // 通常のスクロールエフェクトさせる
  if ($elm.length) {
    inView.offset({
      bottom: 60
    });
    inView('.js-scroll').on('enter', function($target) {
      // $target.classList.add('effect-is-active');
      $target.classList.add('effect-is-active');
    });
  } else {
    // console.log('hoge');
  }
}());
